import { render, staticRenderFns } from "./ElementaryCourse.vue?vue&type=template&id=a34c3aca"
import script from "./ElementaryCourse.vue?vue&type=script&lang=js"
export * from "./ElementaryCourse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports